/**
 * Do not edit directly
 * Generated on Wed, 30 Aug 2023 11:19:23 GMT
 */

export const SDS_MOTION_DURATION_FASTEST = "100ms"; // Fastest duration, used in buttons and toggles
export const SDS_MOTION_DURATION_FASTER = "150ms"; // Faster duration, used in fading effects
export const SDS_MOTION_DURATION_FAST = "200ms"; // Fast duration, used in small expansions and short distance movements
export const SDS_MOTION_DURATION_MODERATE = "250ms"; // Moderate duration, used in medium expansions and system communication
export const SDS_MOTION_DURATION_DEFAULT = "300ms"; // Default duration, used in large expansions and important system notification
export const SDS_MOTION_DURATION_SLOW = "500ms"; // Slow duration, used in advanced animations and background dimming
export const SDS_MOTION_EASING_DEFAULT = "0.33, 0, 0.34, 1"; // Standard easing (ease in and out)
export const SDS_MOTION_EASING_ENTRY = "0, 0, 0.3, 1"; // Decelerating curve (ease out), for appearance motion
export const SDS_MOTION_EASING_EXIT = "0.5, 0, 1, 1"; // Accelerating curve (ease in), for disappearance motion
export const SDS_MOTION_EASING_EXPRESSIVE = "0.46, 0, 0.19, 1"; // A more steep curve for making motion stand out
export const SDS_MOTION_EASING_ELASTIC = "0.65, -0.01, 0.51, 1.26"; // A curve with an elastic overshoot
export const SDS_MOTION_EASING_LINEAR = "0, 0, 1, 1"; // No easing
